import { Language } from '@/lib/interfaces/interfaces'

const GOOGLE_REVIEW_URL_REGEX = /^https:\/\/(g\.page\/r\/.+|search\.google\.com\/(local\/writereview|maps)|maps\.(google\.com|app\.goo\.gl)|(www\.)?google\.com\/maps)/i

export const isValidGoogleReviewUrl = (url: string): boolean =>
  GOOGLE_REVIEW_URL_REGEX.test(url)

export const GOOGLE_REVIEW_LABELS: Record<Language, string> = {
  es: 'Deja tu reseña',
  en: 'Leave a review',
  fr: 'Donnez votre avis',
  ca: 'Deixa la teva ressenya',
  de: 'Bewertung hinterlassen',
  eu: 'Utzi zure iritzia'
}

export const GOOGLE_REVIEW_COPY: Record<Language, { title: string; description: string; button: string }> = {
  es: { title: 'Cuéntanos tu experiencia', description: 'Tu opinión es muy importante para nosotros. Ayúdanos a mejorar con solo un clic.', button: 'Deja tu valoración' },
  en: { title: 'Share your experience', description: 'Your opinion matters to us. Help us improve with just one click.', button: 'Leave a rating' },
  fr: { title: 'Partagez votre expérience', description: 'Votre avis est très important pour nous. Aidez-nous à nous améliorer en un clic.', button: 'Donnez votre avis' },
  ca: { title: 'Comparteix la teva experiència', description: 'La teva opinió és molt important per a nosaltres. Ajuda\'ns a millorar amb un sol clic.', button: 'Deixa la teva valoració' },
  de: { title: 'Teilen Sie Ihre Erfahrung', description: 'Ihre Meinung ist uns sehr wichtig. Helfen Sie uns, mit nur einem Klick besser zu werden.', button: 'Bewertung abgeben' },
  eu: { title: 'Partekatu zure esperientzia', description: 'Zure iritzia oso garrantzitsua da guretzat. Lagun iezaguzu hobetzen klik bakar batekin.', button: 'Utzi zure balorazioa' }
}
